export const reducerCases = {
  SET_USER: "SET_USER"
};
